import { jsx as _jsx } from "react/jsx-runtime";
import './Icon.scss';
import { SIZE } from '../../constants';
export { SIZE };
export const Icon = (props) => {
    let className = '';
    className += props.size === SIZE.SML ? ' sg-icon-sml' : '';
    className += props.size === SIZE.MED ? ' sg-icon-med' : '';
    className += props.badge ? ` sg-icon-hasBadge sg-icon-${props.badge}` : '';
    return (_jsx("span", { className: 'sg-icon' + className, title: props.tooltip, children: _jsx("span", { className: 'sg-icon--svg', children: props.element }) }));
};
//# sourceMappingURL=Icon.js.map